import { ParticipantLabel } from '@seen/core/models/participantLabel'
import { type ReactNode, useCallback } from 'react'
import { LabelCombobox } from '#src/components/LabelCombobox.tsx'
import { useCreateMutation } from '#src/hooks/useCreateMutation.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function ParticipantLabelCombobox({
  value,
  onChange,
  children,
}: {
  value: ParticipantLabel['referenceString'][]
  onChange: (value: ParticipantLabel['referenceString'][]) => any
  children: ReactNode
}): ReactNode {
  const { data: labels } = useSearch(
    ParticipantLabel,
    ParticipantLabel.baseSearchQuery()
  )
  const createMutation = useCreateMutation<ParticipantLabel>()
  const createParticipantLabel = createMutation.mutate
  const currentPractitioner = useCurrentPractitioner()
  const onCreate = useCallback(
    (name: string, color: string) => {
      createParticipantLabel(
        new ParticipantLabel({
          name,
          color,
          author: currentPractitioner.reference,
        }),
        {
          onSuccess: (l) => {
            onChange([...value, l.referenceString])
          },
        }
      )
    },
    [value, onChange, createParticipantLabel, currentPractitioner.reference]
  )
  return (
    <LabelCombobox
      labels={labels}
      value={value}
      onChange={onChange}
      onCreate={onCreate}
      isCreating={createMutation.isPending}
    >
      {children}
    </LabelCombobox>
  )
}
